// src/components/Footer.jsx
import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleSocialClick = (url) => (e) => {
    e.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Redes Sociais */}
        <div className="footer-social">
          <a
            href="https://www.facebook.com/profile.php?id=61571206525088"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleSocialClick('https://www.facebook.com/profile.php?id=61571206525088')}
            className="footer-social-link"
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.instagram.com/carga_facil_lda?igsh=MXNwMHpsNnEzbXdwMA=="
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleSocialClick('https://www.instagram.com/carga_facil_lda?igsh=MXNwMHpsNnEzbXdwMA==')}
            className="footer-social-link"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/company/carga-facil-lda/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleSocialClick('https://www.linkedin.com/company/carga-facil-lda/')}
            className="footer-social-link"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
        </div>

        {/* Copyright com título Carga Fácil */}
        <div className="footer-copyright">
          <span className="footer-brand">Carga Fácil</span>
          <span className="footer-divider-copy">|</span>
          <span className="footer-rights">
            &copy; {currentYear} Todos os direitos reservados.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;